import type { ReactNode } from 'react';
import React from 'react';
import { StyleSheet, View, type ViewStyle } from 'react-native';

import { theme } from '@garnish/constants';

import { useNavbarContainerHeight } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const FloatingButtonsContainer = (props: Props) => {
  const { children, anchor, style } = props;

  const { offsetStyle: navbarOffsetStyle } = useNavbarContainerHeight();

  // ─── Flags ───────────────────────────────────────────────────────────

  // ─── Styles ──────────────────────────────────────────────────────────

  const containerStyles = [styles.container, navbarOffsetStyle, style, getAnchorStyle(anchor)];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View pointerEvents="box-none" style={containerStyles}>
      {children}
    </View>
  );
};

// ─── Helpers ─────────────────────────────────────────────────────────────────

function getAnchorStyle(anchor: Props['anchor'] = 'right') {
  return {
    left: styles.anchorLeft,
    right: styles.anchorRight,
    full: styles.anchorFull,
  }[anchor];
}

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    bottom: 0,
    padding: theme.spacing['4'],
    gap: theme.spacing['4'],
  },
  anchorLeft: {
    left: 0,
  },
  anchorRight: {
    right: 0,
  },
  anchorFull: {
    left: 0,
    right: 0,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  style?: ViewStyle;
  anchor?: 'left' | 'right' | 'full';
  children: ReactNode;
};
